<template>
  <div>
	  	<div class="integration l-grid l-grid--center">
			<div class="l-grid__col-lg">
				<span v-html="$t('home.corelogicIntegrationSummary1')"></span>&nbsp;
				<a @click="scroll" class="link link--arrow link--white">{{ $t('general.learnMore') }}</a>
			</div>
			<div class="l-grid__col-lg">
				<div class="integration__text">{{ $t('home.corelogicIntegrationSummary2') }}</div>
				<img :src="require('@/assets/' + ($i18n.locale != 'fr-CA' ? 'corelogic-white' : 'centris-white') + '.svg')" class="integration__image"/>
			</div>
		</div>

		<div class="separator separator--gradient">
			<div class="l-grid l-g-50 l-text--center">
				<div class="l-grid__col-lg">
					<section class="section-wrapper">
						<h1 class="title" v-html="$i18n.locale.includes('US') ? $t('mobileName') : 'Prospects <span class=\'u-weight-bolder\'>Mobile</span>'"></h1>
						<p class="text">
							{{ $t('home.mobileSummary') }}
							<router-link class="link link--arrow" :to="$locale.toRouteLinkProp('mobile')">{{ $t('general.learnMore') }}</router-link>
						</p>
						<img :src="require('@/assets/pages/home/' + $t('home.homeMobile.image'))" class="products-image"/>
					</section>
				</div>
				<div class="l-grid__col-lg">
					<section class="section-wrapper">
						<h1 class="title u-color-red">Prospects <span class="u-weight-bolder">CRM</span></h1>
						<p class="text">
							{{ $t('home.crmSummary') }}
							<router-link class="link link--arrow" :to="$locale.toRouteLinkProp('crm')">{{ $t('general.learnMore') }}</router-link>
						</p>
						<img :src="require('@/assets/pages/home/' + $t('home.homeCrm.image'))" class="products-image"/>
					</section>
				</div>
			</div>
		</div>

		<div class="separator" id="corelogic_integration">
			<div class="page-wrapper">
				<div class="jumbotron">
					<section class="section-wrapper section-wrapper--large">
						<h1 class="title" v-html="$t('home.integrationsTitle')"></h1>
						<p class="text">{{ $t('home.integrationsText') }}</p>
						<div class="l-grid l-grid--center l-text--center">
							<div class="l-py-20 l-grid__col-100 l-grid__col-lg l-grid l-grid--column l-grid--center l-grid--justify-center">
								<img src="@/assets/logo.svg" class="corelogic-integration__image" />
							</div>
						</div>
					</section>
				</div>
			</div>
		</div>

		<div class="separator separator--background" v-if="$i18n.locale != 'fr-CA'">
			<div class="jumbotron">
				<section class="section-wrapper section-wrapper--large">
					<h1 class="title">{{ $t('home.mlsTitle') }}</h1>
					<p class="text">{{ $t('home.mlsText') }}</p>
					<router-link class="button button--secondary button--large" :to="$locale.toRouteLinkProp('associations')">{{ $t('general.learnMore') }}</router-link>
				</section>
			</div>
		</div>

		<div class="jumbotron jumbotron--image" :style="`background-image: url('${require('@/assets/faces-mosaic.jpg')}');`">
			<h1 class="title title--white">
				{{ $t('home.jumbotron1') }}<br/>
				<span class="u-weight-bolder">{{ $t('home.jumbotron2') }}</span>
			</h1>
		</div>
  </div>
</template>


<script>
import AppBox from '@/components/utils/AppBox.vue'
//import BoardsCarousel from '@/components/utils/BoardsCarousel.vue'

export default {
	components: { AppBox },

	mounted () {

	},

	data () {
		return {

		}
	},

	computed: {

	},

	methods: {
		scroll() {
			document.querySelector('#corelogic_integration').scrollIntoView({behavior: 'smooth' });
		}
	}
}
</script>

<style scoped>
	.integration { height: 15vh; background: #cc0000; color: white; font-weight: 600; text-align: center; }
	.integration__text { height: 5vh; line-height: 5vh; display: inline-flex; margin-right: 20px; padding-right: 20px; border-right: 1px solid white; }
	.integration__image { height: 5vh; }
	.products-image { height: 380px; }
	.corelogic-integration__image { max-height: 100px; max-width: 500px; }
	.grid-separator { border-left: 1px solid #9b9b9b; margin-left: 30px; padding-left: 30px; }

	.integration__text:only-child,
	.grid-separator:only-child { border: 0!important; }

	@media (max-width: 900px) {
		.products-image { max-width: 100%; height: auto; display: block; margin: auto; }
		.integration { height: auto; padding: 40px 20px; }
		.integration__image { display: block; margin: auto; }
		.integration__text { height: auto; line-height: auto; margin-right: 0; padding-right: 0; border-right: none; margin-top: 20px; }
		.grid-separator { border-left: none; margin-left: 0; padding-left: 0; }
	}
</style>
